import translate, { IntlMessageKeys } from '../../i18n'
import {
  PlanSubscriptionAutoRenewStatus,
  PlanSubscriptionCyclePurchaseType,
  PlanSubscriptionCycleStatus,
  PlanSubscriptionStatus,
} from './share-type'

export const planSubscriptionStatusOptions = Object.values(PlanSubscriptionStatus).map(value => ({
  value,
  label: translate(`planSubscriptions.status.${value}` as IntlMessageKeys),
}))

export const planSubscriptionAutoRenewStatusOptions = Object.values(
  PlanSubscriptionAutoRenewStatus,
).map(value => ({
  value,
  label: translate(`planSubscriptions.autoRenewStatus.${value}` as IntlMessageKeys),
}))

export const getPlanSubscriptionStatusLabel = (status: PlanSubscriptionStatus) =>
  translate(`planSubscriptions.status.${status}` as IntlMessageKeys)

export const getPlanSubscriptionAutoRenewStatusLabel = (status: PlanSubscriptionAutoRenewStatus) =>
  translate(`planSubscriptions.autoRenewStatus.${status}` as IntlMessageKeys)

export const getPlanSubscriptionCycleStatusLabel = (status: PlanSubscriptionCycleStatus) =>
  translate(`planSubscriptions.cycleStatus.${status}` as IntlMessageKeys)

export const getPlanSubscriptionCyclePurchaseTypeLabel = (
  purchaseType: PlanSubscriptionCyclePurchaseType,
) => translate(`planSubscriptions.purchaseType.${purchaseType}` as IntlMessageKeys)
